import React from 'react';
import { DefaultTitle } from '../../se/components/entity/EntityRouter';

import { PatientNameColumn } from '../entities/patient/columns';

export default ({ data }) => (data ? <PatientNameColumn data={data} Text={DefaultTitle} /> : null);
